import styled, { css } from "styled-components";
import { globalTheme } from "./Theme";

const textStyles = css`
  display: ${props => (props.display ? `${props.display};` : "block;")}
    ${({ font144 }) => font144 && "font-size: 144px; line-height: 100%;"}
    ${({ font96 }) => font96 && "font-size: 96px; line-height: 100%;"}
    ${({ font64 }) => font64 && "font-size: 64px; line-height: 120%;"}
    ${({ font36 }) => font36 && "font-size: 36px; line-height: 120%;"}
    ${({ font30 }) => font30 && "font-size: 30px; line-height: 120%;"}
    ${({ font28 }) => font28 && "font-size: 28px; line-height: 120%;"}
    ${({ font24 }) => font24 && "font-size: 24px; line-height: 120%;"}
    ${({ font20 }) => font20 && "font-size: 20px; line-height: 120%;"}
    ${({ font18 }) => font18 && "font-size: 18px; line-height: 120%;"}
    ${({ font16 }) => font16 && "font-size: 16px; line-height: 120%;"}
    ${({ font15 }) => font15 && "font-size: 15px; line-height: 120%;"}
    ${({ font14 }) => font14 && "font-size: 14px; line-height: 120%;"}
    ${({ font13 }) => font13 && "font-size: 13px; line-height: 150%;"}
    ${({ font12 }) => font12 && "font-size: 12px; line-height: 120%;"}
    ${({ font11 }) => font11 && "font-size: 11px; line-height: 150%;"}
    ${({ font10 }) => font10 && "font-size: 10px; line-height: 120%;"}
    ${({ mont, thin }) => mont && thin && `font-family: ${globalTheme.fonts.montThin}; font-weight: 100;`}
    /* ${({ mont, extraLight }) => mont && extraLight && `font-family: ${globalTheme.fonts.montExtraLight}; font-weight: 200;`} */
    ${({ mont, light }) => mont && light && `font-family: ${globalTheme.fonts.montLight}; font-weight: 300;`}
    ${({ mont, regular }) => mont && regular && `font-family: ${globalTheme.fonts.montRegular}; font-weight: 400;`}
    ${({ mont, semiBold }) => mont && semiBold && `font-family: ${globalTheme.fonts.montSemiBold}; font-weight: 500;`}
    ${({ mont, bold }) => mont && bold && `font-family: ${globalTheme.fonts.montBold}; font-weight: 700;`}
    ${({ mont, heavy }) => mont && heavy && `font-family: ${globalTheme.fonts.montHeavy}; font-weight: 800;`}
    ${({ inter, thin }) => inter && thin && "font-family: inter; font-weight: 100;"}
    ${({ inter, extraLight }) => inter && extraLight && "font-family: inter; font-weight: 200;"}
    ${({ inter, light }) => inter && light && "font-family: inter; font-weight: 300;"}
    ${({ inter, regular }) => inter && regular && "font-family: inter; font-weight: 400;"}
    ${({ inter, medium }) => inter && medium && "font-family: inter; font-weight: 500;"}
    ${({ inter, semiBold }) => inter && semiBold && "font-family: inter; font-weight: 600;"}
    ${({ inter, bold }) => inter && bold && "font-family: inter; font-weight: 700;"}
    ${({ inter, heavy }) => inter && heavy && "font-family: inter; font-weight: 800;"}
    ${({ inter, thin }) => inter && thin && 'font-family: "Inter", sans-serif; font-weight: 100;'}
    ${({ inter, extraLight }) => inter && extraLight && 'font-family: "Inter", sans-serif; font-weight: 200;'}
    ${({ inter, light }) => inter && light && 'font-family: "Inter", sans-serif; font-weight: 300;'}
    ${({ inter, regular }) => inter && regular && 'font-family: "Inter", sans-serif; font-weight: 400;'}
    ${({ inter, medium }) => inter && medium && 'font-family: "Inter", sans-serif; font-weight: 500;'}
    ${({ inter, semiBold }) => inter && semiBold && 'font-family: "Inter", sans-serif; font-weight: 600;'}
    ${({ inter, bold }) => inter && bold && 'font-family: "Inter", sans-serif; font-weight: 700;'}
    ${({ inter, heavy }) => inter && heavy && 'font-family: "Inter", sans-serif; font-weight: 800;'}
    ${({ red }) => red && `color: ${globalTheme.colors.red};`}
    ${({ white }) => white && `color: ${globalTheme.colors.white};`}
    ${({ black }) => black && `color: ${globalTheme.colors.black4};`}
    ${({ black1 }) => black1 && `color: ${globalTheme.colors.nuetral8};`}
    ${({ black2 }) => black2 && `color: ${globalTheme.colors.nuetral13};`}
    ${({ black3 }) => black3 && `color: ${globalTheme.colors.black3};`}
    ${({ black4 }) => black4 && `color: ${globalTheme.colors.black4};`}
    ${({ grey1 }) => grey1 && `color: ${globalTheme.colors.grey1};`}
    ${({ grey2 }) => grey2 && `color: ${globalTheme.colors.grey2};`}
    ${({ grey3 }) => grey3 && `color: ${globalTheme.colors.grey3};`}
    ${({ grey4 }) => grey4 && `color: ${globalTheme.colors.grey4};`}
    ${({ primary }) => primary && `color: ${globalTheme.colors.primary};`}
    ${({ grey6 }) => grey6 && `color: ${globalTheme.colors.grey6};`}
    ${({ grey8 }) => grey8 && `color: ${globalTheme.colors.grey8};`}
    ${({ green }) => green && `color: ${globalTheme.colors.green5};`}
    ${({ blue4 }) => blue4 && `color: ${globalTheme.colors.blue4};`}
    ${({ blue6 }) => blue6 && `color: ${globalTheme.colors.blue6};`}
    ${({ green2 }) => green2 && `color: ${globalTheme.colors.green2};`}
    ${({ nuetral2 }) => nuetral2 && `color: ${globalTheme.colors.nuetral2};`}
    ${({ nuetral13 }) => nuetral13 && `color: ${globalTheme.colors.nuetral13};`}
    ${({ nuetral6 }) => nuetral6 && `color: ${globalTheme.colors.nuetral6};`}
    ${({ textCenter }) => textCenter && "text-align: center;"}
    ${({ textRight }) => textRight && "text-align: right;"}
    ${({ color }) => color && `color: ${color};`}
    ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}%;`}
    ${({ uppercase }) => uppercase && `text-transform: uppercase;`}
    ${({ capitalize }) => capitalize && `text-transform: capitalize;`}
    ${({ Italic }) => Italic && `font-style: italic;`}
    ${({ auto }) => auto && `margin: auto;`}
    ${({ width }) => width && `width: ${width};`}
    ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
    ${({ cursor }) => cursor && `cursor: ${cursor};`}

    ${({ lineClamp, maxWidth }) => lineClamp && css`
      display: -webkit-box;
      -webkit-line-clamp: ${lineClamp};
      -webkit-box-orient: vertical;
      overflow: hidden;
      max-width: ${maxWidth};
    `}
`;

// here defining all the styling props that should be filtered out
const shouldForwardProp = prop => {
  const stylingProps = [
    // Font sizes
    'font144', 'font96', 'font64', 'font36', 'font30', 'font28', 'font24', 'fontSize13', 'fontSize12',
    'font20', 'font18', 'font16', 'font15', 'font14', 'font13', 'font12', 'font11', 'font10', 'font15',

    // Font families and weights
    'mont', 'inter', 'thin', 'extraLight', 'light', 'regular', 'medium', 'normal',
    'semiBold', 'bold', 'heavy', 'semibold', 'Italic', 'maxWidth', 'lineClamp',

    // Colors
    'red', 'white', 'black', 'black1', 'black2', 'black3', 'black4',
    'grey1', 'grey2', 'grey3', 'grey4', 'grey6', 'grey8', 'blue4', 'nuetral12',
    'green', 'green2', 'primary', 'Black1', 'Black2', 'Black3', 'Black4',
    'nuetral2', 'neutral13', 'nuetral6', 'neutral6', 'nuetral13', 'secondary', 'error', 'blue',

    // Text alignment and styling
    'textCenter', 'textLeft', 'textRight', 'uppercase', 'capitalize', 'textleft',
    'lineHeight', 'auto', 'underline', 'cursor',
  ];

  return !stylingProps.includes(prop);
};

const BaseSpanStyled = styled.span.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const BaseTextStyled = styled.p.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H1Styled = styled.h1.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H2Styled = styled.h2.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H3Styled = styled.h3.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H4Styled = styled.h4.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H5Styled = styled.h5.withConfig({
  shouldForwardProp,
})`${textStyles}`;

const H6Styled = styled.h6.withConfig({
  shouldForwardProp,
})`${textStyles}`;

export const Heading1 = ({ children, className, onClick, color, ...props }) => (
  <H1Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H1Styled>
);

export const Heading2 = ({ children, className, onClick, color, ...props }) => (
  <H2Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H2Styled>
);

export const Heading3 = ({ children, className, onClick, color, ...props }) => (
  <H3Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H3Styled>
);

export const Heading4 = ({ children, className, onClick, color, ...props }) => (
  <H4Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H4Styled>
);

export const Heading5 = ({ children, className, onClick, color, ...props }) => (
  <H5Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H5Styled>
);

export const Heading6 = ({ children, className, onClick, color, ...props }) => (
  <H6Styled {...props} className={className} onClick={onClick} style={(color ? { color } : {})}>{children}</H6Styled>
);

export const Text = ({ children, className, onClick, color, style, ...props }) => (
  <BaseTextStyled {...props} className={className} onClick={onClick} style={{ ...style, ...(color && { color }) }}>{children}</BaseTextStyled>
);

export const Span = ({ children, className, onClick, color, style, ...props }) => (
  <BaseSpanStyled {...props} className={className} onClick={onClick} style={{ ...style, ...(color && { color }) }}>{children}</BaseSpanStyled>
);